import { GetAllergyResponse } from "@veris-health/med-data-ms/lib/v1";
import { allergiesApiV1 } from "../../../api";
import { stripHtml } from "../../../api/stripHtml";

export const fetchAllergiesData = async (patientId: number): Promise<GetAllergyResponse[]> => {
  const response = await allergiesApiV1.getAllergies(patientId);
  const allergies = stripHtml(response.data) as GetAllergyResponse[];
  return allergies;
};
